"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var orderListApi = _interopRequireWildcard(require("@/api/orderListApi.js"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/** 与 lists/orderDetail.vue 中 getOrderDetail 返回结构对齐，再映射到本弹窗各区块字段（不改模板字段名） */
function mapStoreOrderToIntegralDialog(res) {
  if (!res || _typeof(res) !== 'object') return null;
  var op = res.orderPay || {};
  var od = res.orderDelivery || {};
  var useIntegral = Number(op.useIntegral) || 0;
  var totalPrice = Number(op.totalPrice) || 0;
  var freightPrice = Number(op.freight) || 0;
  var orderTotalPriceNum = totalPrice + freightPrice;
  var fmtY = function fmtY(n) {
    if (n == null || n === '') return '—';
    var v = Number(n);
    if (Number.isNaN(v)) return '—';
    return "\xA5".concat(v.toFixed(2));
  };
  var fmtDiscount = function fmtDiscount(n) {
    if (n == null || n === '' || Number(n) === 0) return '—';
    var v = Number(n);
    if (Number.isNaN(v)) return '—';
    return "- \xA5".concat(Math.abs(v).toFixed(2));
  };
  /** 福豆抵扣为虚拟数量，不展示人民币符号，仅「-」+ 数值 */
  var fmtFudouDeduct = function fmtFudouDeduct(n) {
    if (n == null || n === '' || Number(n) === 0) return '—';
    var v = Number(n);
    if (Number.isNaN(v)) return '—';
    return "-".concat(Math.abs(v).toFixed(2));
  };
  /** 福豆抵扣取 orderPay.useIntegral（与下方 orderTotalPrice 推导所用一致） */
  var fudouDeductVal = useIntegral === 0 ? '—' : fmtFudouDeduct(useIntegral);
  var pointRaw = op.payShopIntegral;
  var pointDeductVal = pointRaw != null && pointRaw !== '' && Number(pointRaw) !== 0 ? "-".concat(pointRaw) : '—';
  var pointPriceRaw = res.payShopIntegralPrice;
  var pointDeductAmountVal = pointPriceRaw != null && pointPriceRaw !== '' && Number(pointPriceRaw) !== 0 ? fmtDiscount(pointPriceRaw) : '—';
  var couponRaw = op.couponPrice;
  var couponDeductVal = couponRaw != null && couponRaw !== '' && Number(couponRaw) !== 0 ? fmtDiscount(couponRaw) : '—';
  var items = (res.orderItemList || []).map(function (it) {
    var ar = (it.aftersaleAndAmount || []).map(function (x) {
      return x && x.afterSaleId ? "".concat(x.afterSaleId, "-").concat(x.amount, "\u5143") : '';
    }).filter(Boolean);
    return {
      skuId: it.skuId,
      code: it.skuCode,
      name: it.skuName,
      attr: it.skuAttr,
      qty: it.skuQuantity,
      unitPrice: it.skuPrice,
      totalPrice: it.skuTotalPrice,
      image: it.skuImg || '',
      shipStatus: it.isShipped === 1 ? '已发货' : '未发货',
      aftersaleId: it.aftersaleAndAmount && it.aftersaleAndAmount.length ? it.aftersaleAndAmount[0].afterSaleId : '',
      aftersaleStatusDesc: res.aftersaleStatusDesc != null && res.aftersaleStatusDesc !== '' ? String(res.aftersaleStatusDesc) : '有售后',
      hasAftersale: Boolean(it.aftersaleAndAmount && it.aftersaleAndAmount.length),
      aftersaleAndAmount: it.aftersaleAndAmount || [],
      relatedAftersale: ar.length ? ar.join('、') : '--'
    };
  });
  return {
    base: {
      orderNo: res.orderNo != null ? String(res.orderNo) : '—',
      orderStatus: res.statusName != null ? String(res.statusName) : '—',
      logisticsStatus: res.deliveryStatusName != null ? String(res.deliveryStatusName) : '—',
      relatedAftersale: Number(res.saleAfter) === 1 ? res.aftersaleStatusDesc != null && res.aftersaleStatusDesc !== '' ? String(res.aftersaleStatusDesc) : '有售后' : res.aftersaleStatusDesc != null && res.aftersaleStatusDesc !== '' ? String(res.aftersaleStatusDesc) : '无售后',
      hasAftersale: Number(res.saleAfter) === 1,
      orderTag: res.orderTagStr != null && res.orderTagStr !== '' ? String(res.orderTagStr) : res.tagName || '—',
      customerRemark: res.userRemark != null ? String(res.userRemark) : '—',
      buyerPhone: res.userPhone != null ? String(res.userPhone) : '—',
      orderTime: res.createTime != null ? String(res.createTime) : '—',
      payTime: res.payTime != null ? String(res.payTime) : '—',
      shipTime: res.shipmentsTime != null ? String(res.shipmentsTime) : '—',
      finishTime: res.endTime != null ? String(res.endTime) : '—',
      cancelTime: res.cancelTime != null ? String(res.cancelTime) : '—'
    },
    logistics: {
      receiverName: od.receiverName != null ? String(od.receiverName) : '—',
      receiverPhone: od.receiverPhone != null ? String(od.receiverPhone) : '—',
      receiverAddress: (od.receiverAddress || od.receiverDetailAddr || res.receiverDetailAddr || '') != null ? String(od.receiverAddress || od.receiverDetailAddr || res.receiverDetailAddr || '') : '—'
    },
    items: items,
    payment: {
      orderTotal: Number.isNaN(orderTotalPriceNum) ? '—' : fmtY(orderTotalPriceNum),
      goodsTotal: fmtY(op.totalPrice),
      freight: fmtY(op.freight),
      discount: op.discount != null && op.discount !== '' && Number(op.discount) !== 0 ? fmtDiscount(op.discount) : '—',
      fudouDeduct: fudouDeductVal,
      pointDeduct: pointDeductVal,
      pointDeductAmount: pointDeductAmountVal,
      couponDeduct: couponDeductVal,
      actualPaid: fmtY(op.paidPrice),
      payMethod: op.payTypeName != null && op.payTypeName !== '' ? String(op.payTypeName) : '—'
    },
    discount: {
      methodLabel: '优惠券或立减活动',
      couponAmount: op.couponDiscountAmount != null && op.couponDiscountAmount !== '' && Number(op.couponDiscountAmount) !== 0 ? "-\xA5".concat(Number(op.couponDiscountAmount).toFixed(2)) : '-¥0.00',
      instantAmount: op.immediateDiscountAmount != null && op.immediateDiscountAmount !== '' && Number(op.immediateDiscountAmount) !== 0 ? "-\xA5".concat(Number(op.immediateDiscountAmount).toFixed(2)) : '-¥0.00'
    }
  };
}

/** 无接口数据时的空壳（占位符「—」），与接口返回 merge 后展示 */
function emptyDetail() {
  return {
    base: {
      orderNo: '—',
      orderStatus: '—',
      logisticsStatus: '—',
      relatedAftersale: '—',
      hasAftersale: false,
      orderTag: '—',
      customerRemark: '—',
      buyerPhone: '—',
      orderTime: '—',
      payTime: '—',
      shipTime: '—',
      finishTime: '—',
      cancelTime: '—'
    },
    logistics: {
      receiverName: '—',
      receiverPhone: '—',
      receiverAddress: '—'
    },
    items: [],
    payment: {
      orderTotal: '—',
      goodsTotal: '—',
      freight: '—',
      discount: '—',
      fudouDeduct: '—',
      pointDeduct: '—',
      pointDeductAmount: '—',
      couponDeduct: '—',
      actualPaid: '—',
      payMethod: '—'
    },
    discount: {
      methodLabel: '—',
      couponAmount: '—',
      instantAmount: '—'
    }
  };
}
function deepMerge(target, src) {
  if (!src || _typeof(src) !== 'object') return target;
  var out = _objectSpread({}, target);
  Object.keys(src).forEach(function (k) {
    var sv = src[k];
    var tv = out[k];
    if (sv && _typeof(sv) === 'object' && !Array.isArray(sv) && tv && _typeof(tv) === 'object' && !Array.isArray(tv)) {
      out[k] = deepMerge(tv, sv);
    } else if (sv !== undefined) {
      out[k] = sv;
    }
  });
  return out;
}
var _default = exports.default = {
  name: 'IntegralOrderDetail',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    /** 与 lists/index.vue → orderDetail.openDetail 一致：GET /admin/order/detail/{orderNo}，params: { orderNo } */
    orderNo: {
      type: String,
      default: ''
    },
    /** 与 emptyDetail 同结构，可只传部分字段在接口数据之上再 merge */
    detail: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    return {
      tableHeaderStyle: {
        fontWeight: 'bold',
        background: '#fafafa'
      },
      detailLoading: false,
      /** getOrderDetail 映射后的数据 */
      serverDetail: null
    };
  },
  computed: {
    d: function d() {
      var base = emptyDetail();
      var merged = base;
      if (this.serverDetail) {
        merged = deepMerge(base, this.serverDetail);
      }
      if (this.detail) {
        merged = deepMerge(merged, this.detail);
      }
      return merged;
    },
    payCouponDisplay: function payCouponDisplay() {
      var v = this.d && this.d.payment ? this.d.payment.couponDeduct : '';
      if (v === null || v === undefined || String(v).trim() === '') return '—';
      return v;
    },
    baseFieldRows: function baseFieldRows() {
      var b = this.d.base;
      return [{
        key: 'orderNo',
        label: '订单编号：',
        value: b.orderNo
      }, {
        key: 'orderStatus',
        label: '订单状态：',
        value: b.orderStatus
      }, {
        key: 'logisticsStatus',
        label: '物流状态：',
        value: b.logisticsStatus
      }, {
        key: 'relatedAftersale',
        label: '关联售后：',
        value: b.relatedAftersale
      }, {
        key: 'orderTag',
        label: '订单标签：',
        value: b.orderTag
      }, {
        key: 'customerRemark',
        label: '客户备注：',
        value: b.customerRemark
      }, {
        key: 'buyerPhone',
        label: '下单人手机号：',
        value: b.buyerPhone
      }, {
        key: 'orderTime',
        label: '下单时间：',
        value: b.orderTime
      }, {
        key: 'payTime',
        label: '付款时间：',
        value: b.payTime
      }, {
        key: 'shipTime',
        label: '发货时间：',
        value: b.shipTime
      }, {
        key: 'finishTime',
        label: '完结时间：',
        value: b.finishTime
      }, {
        key: 'cancelTime',
        label: '取消时间：',
        value: b.cancelTime
      }];
    },
    /**
     * 父级同时改 visible + orderNo 时，分别 watch 会各触发一次导致接口打两次。
     * 用「可拉取 key」只在一处监听：打开/切单号各触发一次，关闭时清空。
     */
    detailFetchKey: function detailFetchKey() {
      if (!this.visible || !this.orderNo) return '';
      return String(this.orderNo);
    }
  },
  watch: {
    detailFetchKey: function detailFetchKey(key) {
      if (!key) {
        this.serverDetail = null;
        return;
      }
      this.fetchOrderDetail();
    }
  },
  methods: {
    fetchOrderDetail: function () {
      var _fetchOrderDetail = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              if (this.orderNo) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              this.detailLoading = true;
              _context.p = 2;
              _context.n = 3;
              return orderListApi.getOrderDetail(this.orderNo);
            case 3:
              res = _context.v;
              this.serverDetail = mapStoreOrderToIntegralDialog(res);
              _context.n = 5;
              break;
            case 4:
              _context.p = 4;
              _t = _context.v;
              this.serverDetail = null;
            case 5:
              _context.p = 5;
              this.detailLoading = false;
              return _context.f(5);
            case 6:
              return _context.a(2);
          }
        }, _callee, this, [[2, 4, 5, 6]]);
      }));
      function fetchOrderDetail() {
        return _fetchOrderDetail.apply(this, arguments);
      }
      return fetchOrderDetail;
    }(),
    handleClose: function handleClose() {
      this.$emit('update:visible', false);
    },
    goAftersaleList: function goAftersaleList(orderNo) {
      if (!orderNo || orderNo === '—') return;
      this.$router.push({
        path: '/order/aftersale',
        query: {
          orderNo: String(orderNo)
        }
      });
    },
    navigateToAftersaleDetail: function navigateToAftersaleDetail(aftersaleId) {
      if (!aftersaleId || !this.orderNo) return;
      this.$router.push({
        path: "/order/aftersale/aftersaleDetail/".concat(aftersaleId, "/").concat(this.orderNo, "/2")
      });
    },
    handleDiscountRecord: function handleDiscountRecord() {
      this.$message.info('请在订单列表页查看优惠记录');
    }
  }
};